import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { actions as sagaActions, PREFIX } from './actions'
import { IGlobalStore } from 'src/types/store'
import { ITeamMemberPresence } from 'src/services/auth/users'

export interface IStateData {
  /** teammates by user id; offline users are dropped */
  team: Record<number, ITeamMemberPresence>
  isTeamLoaded: boolean
}

export interface IState {
  communication: TStateCommunications<typeof sagaActions>
  data: IStateData
}

export const initialState: IState = {
  communication: createStateSagaCommunications(sagaActions),
  data: {
    team: {},
    isTeamLoaded: false,
  },
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
